// Imprime apenas o elemento (portal) com a classe informada, com o tamanho de página correto.
// Resolve o problema de "página em branco extra" escondendo todo o resto via display:none.
export function printArea(rootClass, pageCss) {
  const existing = document.getElementById("__west_print_style__");
  if (existing) existing.remove();

  const style = document.createElement("style");
  style.id = "__west_print_style__";
  style.textContent = `@media print {
    @page { ${pageCss} }
    html, body { margin: 0 !important; padding: 0 !important; }
    body > *:not(.${rootClass}) { display: none !important; }
    .${rootClass} { display: block !important; }
    /* Forçar impressão de cores (fundos pretos, tarjas, etc.) — sem isso a Zebra imprime só texto e joga fundo fora. */
    .${rootClass}, .${rootClass} * {
      -webkit-print-color-adjust: exact !important;
      print-color-adjust: exact !important;
      color-adjust: exact !important;
    }
  }`;
  document.head.appendChild(style);

  const cleanup = () => {
    const s = document.getElementById("__west_print_style__");
    if (s) s.remove();
    window.removeEventListener("afterprint", cleanup);
  };
  window.addEventListener("afterprint", cleanup);
  setTimeout(() => window.print(), 80);
  setTimeout(cleanup, 4000);
}
